import { Component, ViewChild, TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Profesional } from '../../../models/profesional_calculista.model';
import { MatDialog } from '@angular/material';
import { FormService } from 'src/app/services/form.service';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';

declare var jQuery: any;
declare var $: any;
@Component({
  selector: 'app-calculista-responsable',
  templateUrl: './calculista-responsable.component.html',
  styleUrls: ['./calculista-responsable.component.css'],
  providers: [UserService, FormService]
})
export class CalculistaResponsableComponent {
  @ViewChild('confirmarReemplazo') confirmarReemplazoTemplate: TemplateRef<any>;
  @ViewChild('openModal') openModal: TemplateRef<any>;
  @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;


  public rut_arq;
  public invalidRut: Boolean;
  public profesional: Profesional;
  public rows = [];
  public actualRow;

  public filteredOptions;
  public nombreComuna = new FormControl('', [Validators.required]);
  options = []
  public selectedCal: number = null;
  public mail_profCalc
  public matcher = new FormService();
  regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  constructor(private fb: FormBuilder, private _userService: UserService, private rutValidator: RutValidator,
    private dialog: MatDialog, private spinner: NgxSpinnerService) {
    this.rut_arq = this.fb.group({
      rut: ['', [Validators.required, this.rutValidator]]
    })

    this.mail_profCalc = this.fb.group({
      mail: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]]
    })
    if (!JSON.parse(localStorage.getItem("calculistaProfesional"))) {
      localStorage.setItem("calculistaProfesional", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("calculistaProfesional"));
    }
    this.invalidRut = true;
    this.profesional = {
      rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '',
      direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: ''
    };
  }


  ngOnInit() {

  }


  ngAfterContentInit() {
    this.getComunas()
    this.filteredOptions = this.nombreComuna.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }

  get_calculista(rut) {
    this.spinner.show();
    this.cleanData();
    this._userService.getCalculista(rut).subscribe(
      response => {
        if (response.message) {
          this.profesional.rut = rut ? rut : '';
          this.spinner.hide();
          this.dialog.open(this.openModal);
        } else {
          this.profesional.rut = response.rut ? response.rut : '';
          this.profesional.nombre = response.nombre ? response.nombre : '';
          this.profesional.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
          this.profesional.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
          this.profesional.direccion = response.direccion ? response.direccion : '';
          this.profesional.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
          this.profesional.direccion_num = response.direccion_num ? response.direccion_num : '';
          this.profesional.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
          this.profesional.comuna = response.comuna ? response.comuna : '';
          this.profesional.fono = response.fono ? response.fono : '';
          this.profesional.fax = response.fax ? response.fax : '';
          this.profesional.mail = response.mail ? response.mail : '';
          this.profesional.patente = response.patente ? response.patente : '';
          this.profesional.recordId = response.recordId ? response.recordId : '';
          this.spinner.hide();
          this.dialog.open(this.openModal);
        }

      },
      error => {
        console.log(error)
      }
    )
  }

  cleanData() {
    this.profesional = {
      rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '',
      direccion: '', direccion_complemento: '', direccion_num: '', direccion_completa: '', comuna: '', fono: '', fax: '', patente: '', recordId: ''
    };
    this.rut_arq.reset()
  }



  update_calculista(rut, id) {
    this.get_calculista(rut);
    this.selectedCal = id;
  }


  savecalculista() {

    //elimina la fila si escriben un rut que ya esté ingresado
    for (let x = 0; x < this.rows.length; x++) {
      if (this.profesional.rut == this.rows[x].rut) {
        this.delete_calculista(x);
      }
    }

    //elimina fila cuando la editan
    /*if (this.selectedCal != null) {
        this.delete_calculista(this.selectedCal);
        this.selectedCal = null;
    }*/

    this.spinner.show();
    this._userService.saveCalculista(this.profesional).subscribe(
      response => {
        this.spinner.hide();

        if (response.update || response.save) {
          $("#arq_modal").modal("hide");
          const stored = localStorage.getItem("calculistaProfesional");
          this.rows = stored ? JSON.parse(stored) : [];

          if (this.rows.length > 0) {
            this.dialog.closeAll()
            const dialogRef = this.dialog.open(this.confirmarReemplazoTemplate, {
              width: '400px',
              disableClose: true,
              data: {}
            });

            dialogRef.afterClosed().subscribe(result => {
              if (result === true) {
                console.log("se quiere reemplazar");
                this.newPropietario()
              }
            });
          } else {
            this.newPropietario()
          }

        }
      },
      error => {
        this.spinner.hide();

        console.log(error)
      }
    )
  }

  newPropietario() {
    // Sobrescribir directamente con un solo objeto
    this.rows = [{
      rut: this.profesional.rut,
      nombre: this.profesional.nombre,
      apellido_mat: this.profesional.apellido_mat,
      apellido_pat: this.profesional.apellido_pat,
      direccion: this.profesional.direccion,
      direccion_num: this.profesional.direccion_num,
      direccion_complemento: this.profesional.direccion_complemento,
      direccion_completa: this.profesional.direccion_completa,
      comuna: this.profesional.comuna,
      fono: this.profesional.fono,
      fax: this.profesional.fax,
      mail: this.profesional.mail,
      patente: this.profesional.patente
    }];

    localStorage.setItem("propietarios", JSON.stringify(this.rows));

    // Resetear campos y cerrar el diálogo
    localStorage.setItem("calculistaProfesional", JSON.stringify(this.rows));
    this.profesional = {
      rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '',
      direccion: '', direccion_complemento: '', direccion_num: '', direccion_completa: '', comuna: '', fono: '', fax: '', patente: '', recordId: ''
    };
    this.rut_arq.reset()
    this.dialog.closeAll();
  }
  delete_calculista(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("calculistaProfesional", JSON.stringify(this.rows));
        this.rows = JSON.parse(localStorage.getItem('calculistaProfesional'));
      }
    }
  }

  getComunas() {

    if (JSON.parse(localStorage.getItem("comunas"))) {
      if (JSON.parse(localStorage.getItem("comunas")).length > 0) {
        this.options = JSON.parse(localStorage.getItem('comunas'));

      } else {
        this.options = []
      }
    }

    this.filteredOptions = this.nombreComuna.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

  }
}
